module.exports = __webpack_public_path__ + "img/nba-newhires.e20fd652.png";